import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningOutlined from '@mui/icons-material/WarningOutlined';
import AlertTitle from '@mui/material/AlertTitle';
import { Banner } from '@src/common/components/Banner';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { ClientOrderSubmissionState } from '@src/orders/domain/ClientOrderSubmissionState';
import { t } from 'i18next';

interface Props {
  submissionState?: ClientOrderSubmissionState | undefined;
}

export const OrderCompletedByClientBanner = ({ submissionState }: Props) => {
  if (submissionState === ClientOrderSubmissionState.COMPLETED) {
    return (
      <Banner severity="info" style={{ width: '100%' }}>
        <InfoOutlinedIcon />
        <Stack flex={1}>
          <AlertTitle>{t('clientOrder.completed.title')}</AlertTitle>
          <Typography>{t('clientOrder.completed.description')}</Typography>
        </Stack>
      </Banner>
    );
  } else if (submissionState === ClientOrderSubmissionState.UNKNOWN) {
    return (
      <Banner severity="warning" style={{ width: '100%' }}>
        <WarningOutlined />
        <Stack flex={1}>
          <AlertTitle>{t('clientOrder.unknown.title')}</AlertTitle>
          <Typography>{t('clientOrder.unknown.description')}</Typography>
        </Stack>
      </Banner>
    );
  }

  return (
    <Banner severity="warning" style={{ width: '100%' }}>
      <WarningOutlined />
      <Stack flex={1}>
        <AlertTitle>{t('clientOrder.partiallyCompleted.title')}</AlertTitle>
        <Typography>
          {t('clientOrder.partiallyCompleted.description')}
        </Typography>
      </Stack>
    </Banner>
  );
};
